import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const Footer = () => {
  const { t, language } = useLanguage();
  
  const getPath = (path) => {
    return language === 'en' ? `/en${path}` : path;
  };

  const footerLinks = [
    { name: t.nav.about, path: getPath('/about') },
    { name: t.nav.services, path: getPath('/services') },
    { name: t.nav.contact, path: getPath('/contact') }
  ];

  return (
    <footer className="bg-black border-t border-[#D6CE15]/20 py-16 mt-32">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <img 
              src="/logo.png" 
              alt="13Labs" 
              className="h-8 w-auto mb-4"
              style={{
                filter: 'brightness(1.1) drop-shadow(0 0 8px rgba(214, 206, 21, 0.4)) drop-shadow(0 0 16px rgba(214, 206, 21, 0.2))'
              }}
            />
            <p className="text-gray-500 text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          {/* Company Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t.footer.company}</h4>
            <div className="flex flex-col space-y-3">
              {footerLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-gray-500 hover:text-[#D6CE15] transition-colors text-sm"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact Info Placeholder */}
          <div>
            <h4 className="text-white font-semibold mb-4">{t.footer.getInTouch}</h4>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              {t.footer.getInTouchText}
            </p>
            <Link
              to={getPath('/contact')}
              className="inline-block text-[#D6CE15] hover:text-[#A4A71E] transition-colors text-sm font-medium"
            >
              {t.footer.contactUs}
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-[#D6CE15]/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-600 text-sm">
              {t.footer.copyright}
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6">
              <Link
                to={getPath('/kasutustingimused')}
                className="text-gray-600 hover:text-[#D6CE15] transition-colors text-sm"
              >
                {t.nav.terms}
              </Link>
              <Link
                to={getPath('/privaatsuspoliitika')}
                className="text-gray-600 hover:text-[#D6CE15] transition-colors text-sm"
              >
                {t.nav.privacy}
              </Link>
              <Link
                to={getPath('/kupsiste-poliitika')}
                className="text-gray-600 hover:text-[#D6CE15] transition-colors text-sm"
              >
                {t.nav.cookies}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;